<script lang="ts" setup>
const props = defineProps<{
  grade: string
}>()

const chipClass = computed(() => utrLetterGradeChipClass(props.grade))
</script>

<template>
  <span
    class="flex w-10 items-center justify-center rounded-sm px-1 py-0.5 text-xs font-semibold text-primal-inverted"
    :class="chipClass"
  >
    {{ grade }}
  </span>
</template>
